import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faTimes } from '@fortawesome/free-solid-svg-icons';
import logo from '../../assets/logo.png';
import bgimage from '../../assets/infographs/apjabdulkalam.png';

const InfoGraphicsMyList = () => {
  const [showExample, setShowExample] = useState(false);

  const toggleExampleView = () => {
    setShowExample(!showExample);
  };

  return (
    <div className='flex justify-center mt-2'>
      <div 
        className='relative'
        style={{
          border: '4px solid purple',
          borderRadius: '15px',  
          width: '500px',  
          padding: '25px',  
          fontFamily: 'Arial, sans-serif',
          textAlign: 'center',
          backgroundColor: '#ececec',  
          color: '#0044cc',  
          boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',  
          position: 'relative',
          overflow: 'hidden',
        }}>
        
        {showExample ? (
          <div className='relative'>
            <img 
              src={bgimage} 
              alt="APJ Abdul Kalam 1"
              style={{ 
                width: '100%', 
                height: '100%', 
                objectFit: 'cover' 
              }} 
            />
            <div 
              style={{
                position: 'absolute',
                bottom: 0,
                width: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',  
                color: '#fff',
                textAlign: 'center',
                padding: '10px 0',
                fontSize: '14px'
              }}>
              अवुल पकिर जैनुलाब्दीन अब्दुल कलाम (APJ Abdul Kalam) का जन्म 15 अक्टूबर, 1931 को तमिलनाडु के रामेश्वरम के गरीब परिवार में हुआ था.
            </div>

            {/* Chevron Left and Right */}
            <div 
              className="absolute left-2 top-1/2 transform -translate-y-1/2 text-red-500 cursor-pointer"
              onClick={() => console.log('Prev clicked')}>
              <FontAwesomeIcon icon={faChevronLeft} size="lg" />
            </div>
            <div 
              className="absolute right-2 top-1/2 transform -translate-y-1/2 text-red-500 cursor-pointer"
              onClick={() => console.log('Next clicked')}>
              <FontAwesomeIcon icon={faChevronRight} size="lg" />
            </div>

            {/* Close (x) Button */}
            <div 
              className="absolute top-2 right-2 text-white cursor-pointer bg-gray-300 bg-opacity-50 rounded-full p-1"
              onClick={toggleExampleView}>
              <FontAwesomeIcon icon={faTimes} size="lg" />
            </div>
          </div>
        ) : (
          <div className="bg-black text-white rounded-md p-4">
            <h2 className='text-teal-200 mt-4 mb-2 font-bold text-2xl'>Infographics Flash Card</h2>
            
            <p className='text-sm text-white mb-2'>Drblackop Max 10 Vertical Orientation Images Here</p>
            <p className='text-sm text-white mb-2'>Images must be a PNG or JPEG/JPG only</p>
            <p className='text-sm text-white mb-6'>Max Image Size Limit Is 250 KB</p>
            
            <p className='text-sm text-white mb-2'>Configure Messages For Every Card</p>
            <p className='text-sm text-white mb-2'>Max 150 Characters Are Allowed For Every Message</p>
            <p className='text-sm text-white mb-2'>Decide & Mark the Placement of Message Overlay on the Image</p>
            <p className='text-sm text-white mb-2'>Check if You Want User Comments</p>
            <p className='text-sm text-white mb-2'>Share Link</p>
            <p className='text-sm text-white mb-2'>View & Reply on Comments</p>
            
            <div className='flex flex-row justify-center text-gray-300 mt-2 mb-2'>
              <p className='text-m mr-4 hover:underline text-gray-300'>Preview 💎</p>
              <p className='text-m mr-4 hover:underline text-gray-300'>Publish 💎</p>
              <p className='text-m mr-4 hover:underline text-gray-300'>Monetize 💎</p>
            </div>

            <button 
              onClick={toggleExampleView}
              className="mt-4 py-2 px-4 bg-purple-600 text-white font-bold rounded hover:bg-purple-700">
              View Example
            </button>
            
            <p className="w-full h-12 bg-yellow-100 text-blue-700 mt-4 text-sm flex items-center justify-center rounded-full shadow-inner">
              Powered by 
              <img 
                src={logo} 
                alt="Think5Whys" 
                style={{ 
                  width: '25px', 
                  height: '25px', 
                  padding: '5px',
                  marginLeft: '5px',
                  marginRight: '5px'
                }} 
              /> 
              think5whys.com
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default InfoGraphicsMyList;
